<template>
<div :class="['nav-content-dashboard-wrapper', {'spinner-is-visible': isSpinnerVisible}]">    
  <div 
    v-if="fulcrumApps.length > 0"
    class="mb-4"
  >
    <h2 style="text-transform: none;">{{ overallStatus.project.label || overallStatus.project.name || 'Recent Project' }}</h2>
    <a 
      :href="'/project_dashboards/' + overallStatus.project.id" 
      :class="['dashboard-card', 'dashboard-card-status-overall', { 'spinner-is-visible': isSpinnerVisible }]"
      title="Go to dashboard"
    >
      <div class="dashboard-card-header align-items-center pb-0">
        <div class="dashboard-card-title">
          Overall Status
        </div>
      </div>
      <div class="dashboard-card-content">
        <BarsChart
          ref="overallStatus"
          v-if="!isSpinnerVisible" 
          title=""
          :data="overallStatus.data"
          bars-min-width="10px"
          :relative-to-highest-value="false"
          :include-counts="true"
          :show-tooltips="false"
        />
      </div>
      <div class="spinner"></div>
    </a>
  </div>

  <div>
    <h2>Recent Dashboards</h2>
    <ul class="nav-menu">
      <li v-for="(app, index) in recentFulcrumApps" :key="index">
        <a :href="'/project_dashboards/' + app.id">{{ app.label || 'Dashboard ' + index }}</a>
      </li>
      <li v-if="recentFulcrumApps.length > 0" role="separator" class="divider"></li>
      <li>
        <a href="/project_dashboards/">All Dashboards</a>
      </li>
    </ul>
  </div>

  <div class="spinner"></div>
</div>
</template>

<script>
import BarsChart from "../shared/stats/bars_chart";

import Helpers from "../../helpers.js";

export default {
  components: {
    BarsChart
  },

  props: {
    policyUpdate: Boolean
  },

  data() {
    return {
      fulcrumApps: [],

      overallStatus: {
        project: {},
        statusesMap: {
          'Visited':      ['Y', 'Y-QC', 'Y-H20', 'Y-H20-QC'],
          'Rejected':     ['Y-R', 'Y-R-QC', 'Y-NRR', 'Y-NRR-QC', 'Y-RR', 'Y-RR-QC', 'Y-UGR', 'Y-UGR-QC'],
          'Priority':     ['Y-PRI', 'Y-PRI-QC'],
          'Not Visited':  ['N', 'N-Pad', 'NI'],
        },
        chartColors: [9, 9, 9, 9],
        totalStatuses: 0,
        data: []
      },

      isSpinnerVisible: true,
    }
  },

  setup () {
    return {
      h$: Helpers
    }
  },

  computed: {
    recentFulcrumApps() {
      return this.fulcrumApps.slice(0, 6);
    }
  },

  methods: {
    init() {
      this.fetchFulcrumApps();
    },

    setFulcrumAppOverallStatus(statuses) {
      let total = 0

      // Step 1: Convert data array to a lookup map
      const dataMap = new Map(statuses.map(([label, count]) => [label, count]));

      // Step 2: Aggregate by inspectionTypesMap
      let overallStatus = Object.entries(this.overallStatus.statusesMap).map(([group, labels]) => {
        let total = labels.reduce((sum, label) => sum + (dataMap.get(label) || 0), 0);
        return [group, total];
      });

      // Step 3: Map chart colors
      overallStatus.forEach((r, index) => {
        total += r[1]

        r.push(this.h$.chartColors[this.overallStatus.chartColors[index]])
      });

      this.overallStatus.totalStatuses = total;
      this.overallStatus.data = overallStatus;
    },

    fetchFulcrumAppOverallStatus: function (fulcrumAppId) {
      app.graphql.get("dashboard.fulcrum.overall",
        {
          appID: fulcrumAppId,
        },

        (data) => {
          const fulcrumRecords = data.data.fulcrumRecords;

          const projectOverallStatus = Object.entries(JSON.parse(fulcrumRecords.overallStatus[0].values))

          this.setFulcrumAppOverallStatus(projectOverallStatus);
        },

        (error) => {
          app.ui.toast.add({
            priority: "danger",
            title: "Something went wrong!",
            message: "Unable to fetch Dashboard records!"
          });
        }
      )
    },
    
    fetchFulcrumApps: function () {
      app.graphql.get("grid.fulcrumApps",
        {
          pageInfo: {
            pageSize: 10,
            currentPage: 1,
            totalCount: 0,
            totalPageCount: 0
          }
        },

        (data) => {
          this.fulcrumApps = data.data.fulcrumApps.edges.map((edge) => {
            return {
              id: edge.node.id,
              label: edge.node.label,
              name: edge.node.name,
              formId: edge.node.formId,
              clientCompany: edge.node.clientCompany,
              lastSync: edge.node.lastSync
            }
          });
          

          // Sort by lastSync date, most recent first
          this.fulcrumApps.sort((a, b) => new Date(b.lastSync) - new Date(a.lastSync));

          this.overallStatus.project = this.fulcrumApps[0];

          this.fetchFulcrumAppOverallStatus(this.overallStatus.project.id);

          this.isSpinnerVisible = false;
        },

        (error) => {
          app.ui.toast.add({
            priority: "danger",
            title: "Something went wrong!",
            message: "Unable to fetch Dashboards!"
          })
        }
      )
    }
  }
}

</script>
